import React from 'react';

import { Review } from '../components/Review';

const container = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  width: '350px',
  margin: 'auto auto'
};

export function Reviews(){
  return (
    <div>
      <h1>Reviews</h1>
      <div style={container}>
      <Review>
          <p>
          I have had chronic pain for over twenty years due to an accident in my teens. 
          I have tried countless practitioners and approaches to achieving relief. 
          Michael has made a lasting difference in reducing my pain and improving my well being. 
          I am so thankful for his technical expertise, willingness to problem solve, 
          and empathetic touch. Michael is a gem.
          </p>
        </Review>
        <Review>
          <p>
            Michael is the best massage therapist, ever. 
            Working with me regularly, he has helped me through some very difficult and chronic issues, 
            both physical and neurological, with great empathy.  His knowledge of the human body is 
            phenomenal. Michael addresses whatever needs to heal with various massage and therapeutic 
            techniques. He manages to get to the root of the issue to ease stiffness, aches and pain. 
            At the same time his treatment is so very calming and relaxing. As with family and friends 
            Michael also treats, I am a very grateful client. 
          </p>
        </Review>
        <Review>
          <p>
            Mike is excellent, very professional, and get this, he comes to your place.
            If you're looking to have a 'treat yourself' day. Book an appointment with Mike
            and your body will thank you for it. I've had a knee problem for most of my adult
            life and Mike has been one of the only massage therapists to help me with it. 
          </p>
        </Review>
      </div>
    </div>
  );
}
